import React from 'react';
import { Helmet } from "react-helmet-async";

const Portfolio = () => {
  return (
    <>
      <Helmet>
        <title>My Portfolio | CryptoBag</title>
        <meta
          name="description"
          content="Track your cryptocurrency portfolio with real-time prices and performance data."
        />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://cryptobag.net/portfolio" />
      </Helmet>

      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fadeIn">
        <div className="bg-gray-800/60 backdrop-blur-sm border border-gray-700/50 p-12 rounded-lg shadow-2xl text-center">
          <h2 className="text-3xl text-white mb-4">Coming Soon!</h2>
          <p className="text-gray-400 max-w-md mx-auto">
            This is where you will be able to connect your wallets or manually track your holdings to see your custom CryptoBag.
          </p>
        </div>
      </div>
    </>
  );
};

export default Portfolio;
